/* Hive collection page — sections/hive-main-collection.liquid
   Switches are ON when those products are shown. Every page starts with
   Sold Out OFF (sold out hidden) and Pre-Orders ON (pre-orders shown).
   - "Sold Out": Shopify's Availability filter through facets.js (correct counts and paging).
     off = filter.v.availability=1 (in stock), on = 1 and 0 (everything). No value in the URL
     means "default", so the script switches it to in stock. If the Availability filter isn't
     turned on in Search & Discovery, sold-out cards are hidden in the page instead.
   - "Pre-Orders": takes pre-order cards out of the honeycomb (so the pattern has no holes)
     and loads more products to keep the grid full.
   - "Load more": appends the next page of cards (the button is a real link without JS).
     The next page is fetched ahead once the button is near (after the page has loaded). */
(function () {
  var AVAIL = 'filter.v.availability';
  var AUTO_FILL_LIMIT = 3; // extra pages fetched in a row to refill the grid
  var PLACE_KEY = 'hive:place';
  var PLACE_TTL = 30 * 60 * 1000; // half an hour; after that they are browsing again, not returning
  var MAX_RESTORE_PAGES = 6; // a long browse must not turn one back button into a dozen requests

  /* The browser restores a scroll offset against a document that no longer has
     the Load more pages in it, which puts the shopper somewhere arbitrary.
     restorePlace() does it properly once the pages are back, so take the
     browser's hands off the wheel first - before it paints, which is why this
     is here and not in the constructor. */
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  } catch (e) {}

  function pageOf(url) {
    var m = /[?&]page=(\d+)/.exec(url || '');
    return m ? parseInt(m[1], 10) : 1;
  }

  function HiveCollection(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.perPage = parseInt(root.dataset.perPage, 10) || 28;
    this.preSwitch = root.querySelector('[data-hcol-preorder]');
    this.soldSwitch = root.querySelector('[data-hcol-soldout]');
    this.nativeSoldout = !!(this.soldSwitch && this.soldSwitch.dataset.native === 'true');
    this.hidePre = false; // Pre-Orders starts ON
    this.hideSold = !!this.soldSwitch && !this.nativeSoldout; // fallback mode: Sold Out starts OFF
    this.loading = false;
    this.firstPage = pageOf(window.location.search); // they may have come in on ?page=3
    this.pagesLoaded = this.firstPage;
    this.restored = false;

    if (this.preSwitch) {
      this.preSwitch.checked = !this.hidePre;
      this.preSwitch.addEventListener('change', this.onPreorder.bind(this));
    }
    if (this.soldSwitch) {
      if (!this.nativeSoldout) this.soldSwitch.checked = !this.hideSold;
      this.soldSwitch.addEventListener('change', this.onSoldout.bind(this));
    }

    root.addEventListener('click', this.onClick.bind(this));
    /* hovering or focusing Load more is a good hint a click is coming */
    var prefetch = this.prefetchNext.bind(this);
    root.addEventListener('pointerover', function (e) { if (e.target.closest('[data-hcol-more]')) prefetch(); });
    root.addEventListener('focusin', function (e) { if (e.target.closest('[data-hcol-more]')) prefetch(); });

    /* don't let the next page compete with this page's images */
    this.loadDone = document.readyState === 'complete';
    if (!this.loadDone) {
      var me = this;
      window.addEventListener('load', function () {
        me.loadDone = true;
        if (me.moreNear) me.prefetchNext();
      });
    }

    /* facets.js swaps #ProductGridContainer after every filter / sort change */
    var container = root.querySelector('#ProductGridContainer');
    if (container && window.MutationObserver) {
      var self = this;
      new MutationObserver(function (records) {
        var replaced = records.some(function (r) {
          return r.target === container && r.type === 'childList';
        });
        if (replaced) self.init();
      }).observe(container, { childList: true });
    }
    window.addEventListener('popstate', this.syncSoldSwitch.bind(this));
    /* pagehide, not unload: unload is never guaranteed on a phone, and it is
       also the thing that stops a page being eligible for the back/forward
       cache in the first place. */
    window.addEventListener('pagehide', this.savePlace.bind(this, null));

    this.init();
  }

  HiveCollection.prototype.init = function () {
    if (this.applyDefaultSoldout()) return; // a re-render with the default is on its way
    this.root.classList.remove('is-defaulting');
    this.grid = this.root.querySelector('[data-hcol-grid]');
    this.autoFills = 0;
    this.items = this.grid ? Array.prototype.slice.call(this.grid.children) : [];
    this.syncSoldSwitch();
    this.watchMore();
    this.apply();
    this.restorePlace();
  };

  /* ---------- switches ---------- */
  HiveCollection.prototype.onPreorder = function () {
    this.hidePre = !this.preSwitch.checked;
    this.autoFills = 0;
    this.apply();
  };

  HiveCollection.prototype.onSoldout = function () {
    var show = this.soldSwitch.checked;
    if (this.nativeSoldout && typeof FacetFiltersForm !== 'undefined') {
      var params = this.cleanParams();
      params.append(AVAIL, '1');
      if (show) params.append(AVAIL, '0');
      FacetFiltersForm.renderPage(params.toString());
      return;
    }
    this.hideSold = !show;
    this.autoFills = 0;
    this.apply();
  };

  HiveCollection.prototype.syncSoldSwitch = function () {
    if (!this.soldSwitch || !this.nativeSoldout) return;
    var values = new URLSearchParams(window.location.search).getAll(AVAIL);
    this.soldSwitch.checked = values.indexOf('0') !== -1;
  };

  HiveCollection.prototype.cleanParams = function () {
    var params = new URLSearchParams(window.location.search);
    params.delete(AVAIL);
    params.delete('page');
    params.delete('section_id');
    return params;
  };

  /* No Availability value in the URL (first visit, "Remove All", back to the start):
     show in-stock only. Returns true when it asked for a re-render. */
  HiveCollection.prototype.applyDefaultSoldout = function () {
    if (!this.nativeSoldout || typeof FacetFiltersForm === 'undefined') return false;
    if (new URLSearchParams(window.location.search).getAll(AVAIL).length) return false;
    var params = this.cleanParams();
    params.append(AVAIL, '1');
    var query = params.toString();
    history.replaceState({ searchParams: query }, '', window.location.pathname + '?' + query + window.location.hash);
    FacetFiltersForm.searchParamsInitial = query; // "back" to this page keeps the default
    this.soldSwitch.checked = false;
    this.root.classList.add('is-defaulting');

    /* the section's inline script started this fetch while the page was parsing; hand it to
       facets.js's cache so renderPage uses it. Only once, so "Remove All" later fetches fresh. */
    var pre = window.__hcolDefault;
    window.__hcolDefault = null;
    if (pre && pre.query === query) {
      pre.html.then(function (html) {
        if (window.location.search.slice(1) !== query) return; // a filter was picked meanwhile
        var cached = FacetFiltersForm.filterData.some(function (e) { return e.url === pre.url; });
        if (html && !cached) FacetFiltersForm.filterData.push({ html: html, url: pre.url });
        FacetFiltersForm.renderPage(query, null, false);
      });
    } else {
      FacetFiltersForm.renderPage(query, null, false);
    }
    return true;
  };

  /* ---------- hide / show cards without leaving holes in the honeycomb ---------- */
  HiveCollection.prototype.isHidden = function (li) {
    return (this.hidePre && li.hasAttribute('data-preorder')) || (this.hideSold && li.hasAttribute('data-soldout'));
  };

  HiveCollection.prototype.apply = function () {
    this.root.classList.toggle('is-hiding-preorders', this.hidePre);
    this.root.classList.toggle('is-hiding-soldout', this.hideSold);
    if (!this.grid) return;

    /* only move cards that are out of place, so cards already on screen stay put
       (re-appending them all restarted their animations). Element siblings, not
       nextSibling, so whitespace between cards doesn't count as "out of place". */
    var self = this;
    var grid = this.grid;
    var prev = null;
    var shown = 0;
    this.items.forEach(function (li) {
      if (self.isHidden(li)) {
        if (li.parentNode) li.parentNode.removeChild(li);
        return;
      }
      shown++;
      var want = prev ? prev.nextElementSibling : grid.firstElementChild;
      if (li !== want) grid.insertBefore(li, want);
      prev = li;
    });
    this.shown = shown;

    var none = this.root.querySelector('[data-hcol-none]');
    var more = this.root.querySelector('[data-hcol-more]');
    if (none) none.hidden = !(shown === 0 && this.items.length > 0 && !more);

    var shownEl = this.root.querySelector('[data-hcol-shown]');
    if (shownEl) shownEl.textContent = shown;

    /* keep the grid full: fetch more when hiding took too many cards out */
    var target = Math.min(this.perPage, this.items.length) * 0.75;
    if (more && shown < target && this.autoFills < AUTO_FILL_LIMIT) {
      this.autoFills++;
      this.loadMore(more);
    }
  };

  /* ---------- load more ---------- */
  HiveCollection.prototype.watchMore = function () {
    if (this.moreIO) this.moreIO.disconnect();
    this.moreIO = null;
    this.moreNear = false;
    var btn = this.root.querySelector('[data-hcol-more]');
    if (!btn || !window.IntersectionObserver) return;
    var self = this;
    this.moreIO = new IntersectionObserver(function (entries) {
      self.moreNear = entries[entries.length - 1].isIntersecting;
      if (self.moreNear && self.loadDone) self.prefetchNext();
    }, { rootMargin: '800px 0px' });
    this.moreIO.observe(btn);
  };

  HiveCollection.prototype.sectionUrl = function (url) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'section_id=' + encodeURIComponent(this.sectionId);
  };

  HiveCollection.prototype.fetchSection = function (url) {
    return fetch(this.sectionUrl(url)).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  };

  /* fetch the next page ahead of the click; loadMore() picks it up */
  HiveCollection.prototype.prefetchNext = function () {
    var btn = this.root.querySelector('[data-hcol-more]');
    if (!btn || this.loading || !this.grid) return;
    if (this.root.classList.contains('is-defaulting')) return; // page 2 of the unfiltered list would be thrown away
    if (navigator.connection && navigator.connection.saveData) return;
    var url = btn.dataset.nextUrl || btn.getAttribute('href');
    if (!url || (this.pf && this.pf.url === url)) return;
    var p = this.fetchSection(url);
    p.catch(function () {}); // a failed prefetch is retried by loadMore()
    this.pf = { url: url, p: p };
  };

  HiveCollection.prototype.onClick = function (event) {
    /* A backstop for the browsers where pagehide does not fire. Normally
       pagehide runs after this and overwrites it with the first card still on
       screen, which is the better anchor of the two — this one only has to be
       right when nothing else gets the chance to run. */
    var link = event.target.closest('a[href]');
    if (link && this.grid && this.grid.contains(link)) this.savePlace(link.closest('li'));

    var more = event.target.closest('[data-hcol-more]');
    if (!more || !this.root.contains(more)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return; // open in new tab
    event.preventDefault();
    this.autoFills = 0;
    this.loadMore(more);
  };

  HiveCollection.prototype.loadMore = function (button) {
    if (this.loading || !this.grid) return;
    var url = button.dataset.nextUrl || button.getAttribute('href');
    if (!url) return;
    var page = pageOf(url);
    this.loading = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var self = this;
    var pf = this.pf;
    this.pf = null;
    var req = pf && pf.url === url
      ? pf.p.catch(function () { return self.fetchSection(url); })
      : this.fetchSection(url);
    req
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('[data-hcol-grid] > li');
        var seen = {};
        self.items.forEach(function (li) {
          var a = li.querySelector('a[href]');
          if (a) seen[a.getAttribute('href')] = true;
        });
        Array.prototype.forEach.call(newItems, function (li) {
          var a = li.querySelector('a[href]');
          if (a && seen[a.getAttribute('href')]) return;
          self.items.push(document.adoptNode(li));
        });

        self.pagesLoaded = Math.max(self.pagesLoaded, page);

        var nextMore = doc.querySelector('[data-hcol-more]');
        if (nextMore) {
          button.dataset.nextUrl = nextMore.dataset.nextUrl;
          button.setAttribute('href', nextMore.getAttribute('href'));
        } else {
          button.parentNode.removeChild(button);
        }
      })
      .catch(function () {
        /* fall back to a normal page load */
        window.location.href = url;
      })
      .then(function () {
        self.loading = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        self.apply();
        self.watchMore(); // re-measure: fetch the page after if the button is still near
      });
  };


  /* ---------- keeping the shopper's place ----------

     Load more appends pages straight into the DOM and never touches history,
     so coming back from a product has nothing to come back to. Measured on the
     live anime collection: 192 cards became 72, and the scroll the browser
     restored on its own landed at 2382 instead of 6000, because the document
     was now a third of the height it had been when the number was recorded.

     That is the part that is easy to miss. Restoring the scroll offset is not
     the job; restoring the pages is, and the offset only means anything
     afterwards.

     The anchor is a card, not the pixel. A phone turned on its side, a font
     that arrives late, a sold-out card filtered out this time — any of those
     move every card on the page, and the pixel then points at the wrong one.
     The anchor is the first card still on screen when they leave, put back at
     the same height on their screen; the pixel is the fallback for when that
     card is no longer in the list at all. */

  HiveCollection.prototype.placeKey = function () {
    /* section_id is ours, never theirs; everything else — filters, sort, the
       page they came in on — makes it a different list, and a place saved in
       one list must not be restored into another. */
    var params = new URLSearchParams(window.location.search);
    params.delete('section_id');
    params.sort();
    return window.location.pathname + '?' + params.toString();
  };

  HiveCollection.prototype.readPlace = function () {
    try {
      var place = JSON.parse(sessionStorage.getItem(PLACE_KEY) || 'null');
      if (!place || place.key !== this.placeKey()) return null;
      if (Date.now() - place.at > PLACE_TTL) return null;
      return place;
    } catch (e) {
      return null; /* private mode, a full quota, something else's bad JSON */
    }
  };

  HiveCollection.prototype.savePlace = function (item) {
    if (!this.grid) return;
    if (!item) {
      /* the first card still on screen: what they were actually looking at */
      var kids = this.grid.children;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].getBoundingClientRect().bottom > 0) { item = kids[i]; break; }
      }
    }
    var link = item && item.querySelector('a[href]');
    try {
      sessionStorage.setItem(PLACE_KEY, JSON.stringify({
        key: this.placeKey(),
        y: Math.round(window.pageYOffset),
        pages: this.pagesLoaded,
        pre: !!(this.preSwitch && this.preSwitch.checked),
        /* pathname only: Shopify hangs _pos / _fid / _ss off these and they
           differ between one render of the same page and the next, so the full
           href would never match itself on the way back */
        anchor: link ? link.getAttribute('href').split('?')[0] : null,
        anchorTop: item ? Math.round(item.getBoundingClientRect().top) : 0,
        at: Date.now()
      }));
    } catch (e) {
      /* storage can be unavailable or full. Losing the place is a small thing;
         throwing here on the way to another page is not. */
    }
  };

  HiveCollection.prototype.restorePlace = function () {
    if (this.restored) return;
    var entry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!entry || entry.type !== 'back_forward') return;
    var place = this.readPlace();
    if (!place) return;
    this.restored = true;

    var self = this;
    try {
      /* Get close with what is already on the page, rather than holding them at
         the top of the collection until the rest of it arrives. The precise
         landing happens below, once the cards are back. */
      this.scrollTo(place.y);

      if (this.preSwitch && this.preSwitch.checked !== place.pre) {
        this.preSwitch.checked = place.pre;
        this.hidePre = !place.pre;
      }

      var last = Math.min(place.pages, this.firstPage + MAX_RESTORE_PAGES - 1);
      this.fetchPages(this.firstPage + 1, last).then(function () {
        self.apply();
        self.watchMore();
        self.scrollToPlace(place);
      });
    } catch (e) {
      /* history.scrollRestoration is 'manual' on this page, so if any of the
         above goes wrong nobody else is going to move the page. */
      this.scrollTo(place.y);
    }
  };

  /* All of them at once, appended in order. They are independent requests, so
     doing them one after another would make the wait their sum instead of the
     longest of them. */
  HiveCollection.prototype.fetchPages = function (from, to) {
    if (to < from || !this.grid) return Promise.resolve();
    var self = this;
    var jobs = [];
    for (var p = from; p <= to; p++) {
      var url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('page', String(p));
      jobs.push(this.fetchSection(url.pathname + url.search).catch(function () { return null; }));
    }

    return Promise.all(jobs).then(function (pages) {
      var seen = {};
      self.items.forEach(function (li) {
        var a = li.querySelector('a[href]');
        if (a) seen[a.getAttribute('href').split('?')[0]] = true;
      });

      var tail;
      pages.forEach(function (html) {
        if (!html) return; /* one page failing should not cost the others */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        Array.prototype.forEach.call(doc.querySelectorAll('[data-hcol-grid] > li'), function (li) {
          var a = li.querySelector('a[href]');
          var href = a && a.getAttribute('href').split('?')[0];
          if (href && seen[href]) return;
          if (href) seen[href] = true;
          self.items.push(document.adoptNode(li));
        });
        tail = doc.querySelector('[data-hcol-more]') || 'end';
      });

      self.pagesLoaded = to;

      /* Load more has to carry on from where they left off, not from page 2 */
      var button = self.root.querySelector('[data-hcol-more]');
      if (button && tail === 'end') {
        button.parentNode.removeChild(button);
      } else if (button && tail) {
        button.dataset.nextUrl = tail.dataset.nextUrl;
        button.setAttribute('href', tail.getAttribute('href'));
      }
    });
  };

  HiveCollection.prototype.scrollTo = function (y) {
    var max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    window.scrollTo(0, Math.max(0, Math.min(Math.round(y), max)));
  };

  HiveCollection.prototype.scrollToPlace = function (place) {
    var y = place.y;
    if (place.anchor && this.grid) {
      var kids = this.grid.children;
      for (var i = 0; i < kids.length; i++) {
        var a = kids[i].querySelector('a[href]');
        if (a && a.getAttribute('href').split('?')[0] === place.anchor) {
          /* that card, back at the height on the screen where they left it */
          y = window.pageYOffset + kids[i].getBoundingClientRect().top - place.anchorTop;
          break;
        }
      }
    }
    this.scrollTo(y);
  };

  function start() {
    document.querySelectorAll('.hcol').forEach(function (root) {
      if (!root.__hcol) root.__hcol = new HiveCollection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
